import './in_page_search_opener.less';

import React from 'react';
import classNames from 'classnames';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';
import { SearchIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';
import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SearchOpenerUi_ViewerVersion1 = ({ onClick, isEmbeded, forceRight }) => (
  <Tipsy content='Open site search' placement='left' mouseEnterDelay={0}>
    <button
      className={classNames('in-page-search-common-styles', {
        'in-page-search-opener': !isEmbeded,
        'force-right': forceRight
      })}
      onClick={onClick}
    >
      <SearchIcon className='in-page-search-icon' />
    </button>
  </Tipsy>
);

const SearchOpenerUi_ViewerVersion2 = ({ onClick, isEmbeded, forceRight }) => (
  <Tipsy content='Open site search' placement='left' mouseEnterDelay={0}>
    <button
      type='button'
      className={classNames('in-page-search-common-styles', {
        'in-page-search-opener': !isEmbeded,
        'force-right': forceRight
      })}
      onClick={onClick}
    >
      <VisuallyHiddenSpan>Open search</VisuallyHiddenSpan>
      <SearchIcon className='in-page-search-icon' />
    </button>
  </Tipsy>
);

const SearchOpenerUi = (props) => (
  <SiteViewerVersionComponentSelector>
    <SearchOpenerUi_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <SearchOpenerUi_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default SearchOpenerUi;
